module.exports = __webpack_public_path__ + "img/859-d14e7f.png";